import React from "react";
import { withStyles } from "@material-ui/core";
import DataGrid from "../../../../../dataGrid"
import GridConfig from "./gridConfig";
import styles from "../../../styles";
import {getDataWithQueryString, postData} from "../../../../../../api/componentAPIs";
import { compose } from "recompose";
import { withSnackbar } from 'notistack';
import MESSAGES from "../../../../../../appMessages";
class ZoneMilesGrid extends React.Component {
    constructor(props){
        super(props);
        this.gridConfig = new GridConfig();
        this.state= {
            zoneMilesData: null,
            errorMessage: null
        }
    }

    componentDidMount(){
        this._isComponentMounted = true;
        this.getzoneMilesData();
    }

    componentWillUnmount(){
        this._isComponentMounted = false;
    }

    componentDidUpdate(prevProps){
        if(this.props.terminalID !== prevProps.terminalID){
            this.getzoneMilesData();
        }
    }

    getzoneMilesData = () => {
        getDataWithQueryString("GetZoneMiles", `terminalId=${this.props.terminalID}`).then(
            response =>{
                if(this._isComponentMounted){
                    if(response && response.status >= 200 && response.status < 400){
                        this.setState({
                            zoneMilesData: this.sortRangeData(response.data),
                            errorMessage: null
                        })
                    }else{
                        this.setState({
                            zoneMilesData: [],
                            errorMessage: MESSAGES.COMMON.GRID_DATA_FETCH_FAILED
                        });
                        this.props.enqueueSnackbar(MESSAGES.ZONE_MILES.FETCH_DATA_FAILURE, {variant: "error"});
                    }
                }
            }, error => {
                if(this._isComponentMounted){
                    this.setState({
                        zoneMilesData: [],
                        errorMessage: MESSAGES.COMMON.GRID_DATA_FETCH_FAILED
                    });
                    this.props.enqueueSnackbar(MESSAGES.ZONE_MILES.FETCH_DATA_FAILURE, {variant: "error"});
                }
            }
        )
    }

    sortRangeData = ( data ) => {
        return data.sort((firstRange, secondRange) => firstRange.lowerRangeMile - secondRange.lowerRangeMile)
    }

    onGridReady = ({api}) => {
        this.gridApi = api;
        this.gridApi.sizeColumnsToFit();
    }

    onCellValueChanged = (params) => {
        if(params.colDef.field === "zoneSpeed" && params.oldValue !== params.newValue){
            if(params.newValue === ""){
                this.props.enqueueSnackbar(MESSAGES.ZONE_MILES.UPDATE_MILES_EMPTY, {variant: "error"});
                params.data[params.colDef.field] = params.oldValue;
                this.gridApi.refreshCells();
            } else {
                this.updateZoneMiles(params);
            }
        }
    }

    updateZoneMiles = (params) => {
        const {zoneSpeedProfileId,lowerRangeMile, higherRangeMile } = params.data;
        const requestParams = {
            terminalId: this.props.terminalID,
            speedProfileDetail: {
                    zoneSpeedProfileId,
                    lowerRangeMile,
                    higherRangeMile,
                    zoneSpeed:params.newValue
                }
        }

        postData("UpdateZoneMiles", requestParams).then(response =>{
                if(response.status === 200){
                    this.props.enqueueSnackbar(`Updated speed for zone miles ${lowerRangeMile}-${higherRangeMile}`, {variant: "success"});
                    if(this._isComponentMounted){
                        this.setState({
                            zoneSpeedData: this.sortRangeData(response.data)
                        });
                    }
                } else {
                    this.props.enqueueSnackbar(`Error updating  speed for zone miles ${lowerRangeMile}-${higherRangeMile}`, {variant: "error"});
                    params.data[params.colDef.field] = params.oldValue;
                    this.gridApi.refreshCells();
                }
        }, error => {
                this.props.enqueueSnackbar(`Error updating  speed for zone miles ${lowerRangeMile}-${higherRangeMile}`, {variant: "error"});
                params.data[params.colDef.field] = params.oldValue;
                this.gridApi.refreshCells();
        });
    }


    render(){
        const { classes } = this.props;
        return (
                    <div className={`${classes.gridContainer}`}>
                        <div className={classes.gridHead}>
                            <span className={classes.gridTitle}> Zone Miles Adjustment </span>
                        </div>
                        <div className={`${classes.dataGrid}`}>
                            {!this.state.errorMessage ? (
                            <DataGrid
                                columnDefs={this.gridConfig.config.columns}
                                config={this.gridConfig.config}
                                enableFilter={this.gridConfig.config.enableFilter}
                                enableSorting={this.gridConfig.config.enableSorting}
                                rowData={this.state.zoneMilesData}
                                onGridReady={this.onGridReady}
                                onCellValueChanged={this.onCellValueChanged}
                                suppressHorizontalScroll={true}
                            />
                            ): (
                                <div className={classes.errorMessageContainer}>
                                        <div className={classes.errorMessage}> {this.state.errorMessage} </div>
                                </div>
                            )}
                        </div>
                  </div>
        )
    }
}

export default compose(withStyles(styles), withSnackbar)(ZoneMilesGrid)